import { render, staticRenderFns } from "./ParameterEdition.vue?vue&type=template&id=2d1dbb0d&scoped=true"
import script from "./ParameterEdition.vue?vue&type=script&lang=js"
export * from "./ParameterEdition.vue?vue&type=script&lang=js"
import style0 from "./ParameterEdition.vue?vue&type=style&index=0&id=2d1dbb0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1dbb0d",
  null
  
)

export default component.exports